<template>
  <div class="related-ticket-card mb-3">
    <!-- Inner -->
    <div class="inner inner-top">
      <a target="_blank" :href="ticketHref"><b class="related-ticket-name">{{ ticket.subject }}</b></a>
    </div>
    <!-- / Inner -->

    <!-- Inner Bottom -->
    <div class="inner inner-bottom">
      <div class="mb-1">
        Opened: {{ formatDate(ticket.created_at) }}
      </div>
      <div>
        Status: {{ getHumanReadableTicketStatus(ticket.status) }}
      </div>
    </div>
    <!-- / Inner Bottom -->
  </div>
</template>

<script>
import Tickets from "../mixins/Tickets";
import Dates from "../mixins/Dates";

export default {
  name: "RelatedTicket",
  props: ['ticket'],
  mixins: [Tickets, Dates],
  computed: {
    ticketHref() {
      return '/tickets/' + this.ticket.id;
    }
  }
}
</script>

<style scoped lang="scss">
.related-ticket-card {
  background: #fff;
  border-radius: 5px;

  .related-ticket-name {
    font-weight: 600;
    color: #2c5cc5;
  }

  .inner {
    padding-left: 15px;
    padding-right: 15px;
  }

  .inner-top {
    padding-top: 12px;
    padding-bottom: 5px;
  }

  .inner-bottom {
    padding-top: 0;
    padding-bottom: 12px !important;
    font-size: 12px;
  }
}
</style>